import { createSelector } from 'reselect';

const selectMeasureWeights = (state: any) => state.measureWeights;


export const selectMeasureWeightsCurrentItem = createSelector([selectMeasureWeights], (measureWeights) => measureWeights.current);

export const selectMeasureWeightsListItems = createSelector([selectMeasureWeights], (measureWeights) => measureWeights.list);

export const selectMeasureWeightsItemById = (itemId: any) =>
    createSelector(selectMeasureWeightsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectMeasureWeightsQueryItems = createSelector([selectMeasureWeights], (measureWeights) => measureWeights.query);

export const selectMeasureWeightsCreatedItem = createSelector([selectMeasureWeights], (measureWeights) => measureWeights.create);

export const selectMeasureWeightsUpdatedItem = createSelector([selectMeasureWeights], (measureWeights) => measureWeights.update);

export const selectMeasureWeightsReadItem = createSelector([selectMeasureWeights], (measureWeights) => measureWeights.read);

export const selectMeasureWeightsDeletedItem = createSelector([selectMeasureWeights], (measureWeights) => measureWeights.delete);

export const selectMeasureWeightsSearchedItems = createSelector([selectMeasureWeights], (measureWeights) => measureWeights.search);

export const selectMeasureWeightsItemsCount = createSelector([selectMeasureWeights], (measureWeights) => measureWeights.count);

export const selectMeasureWeightsItemsFilter = createSelector([selectMeasureWeights], (measureWeights) => measureWeights.filter);